import { initRawSchema } from '@principle-theorem/editor';
import {
  PracticeSetupStepCategory,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { map } from 'rxjs/operators';
import { PracticeSetupStepValidation } from './practice-setup-step-validation';
import {
  IPageVisitTrackingConfig,
  IPracticeSetupStepDefinition,
} from './practice-setup-step.types';

const pageVisitTracking: IPageVisitTrackingConfig = {
  routes: ['settings/brand/{brandId}/accounting'],
  validationMode: 'any',
};

export const transactionTypesStep: IPracticeSetupStepDefinition = {
  id: PracticeSetupStepId.TransactionTypes,
  category: PracticeSetupStepCategory.FeesAndAccounting,
  title: 'Configure Transaction Types',
  description: initRawSchema(
    `Configure manual transaction types. These options can be selected when processing manual transactions. You can add, edit, or delete these to align with your practice's payment methods. Manual transactions are categorized by these labels in reconciliation reporting.`
  ),
  dependsOn: [],
  getRoute: (brand, _practice) => `settings/brand/${brand.ref.id}/accounting`,
  validate$: (practice$, step, options) => {
    return practice$.pipe(
      map((_practice) => {
        if (options?.reviewed || options?.skipped) {
          return { valid: true };
        }

        const pageVisitValidation =
          PracticeSetupStepValidation.validatePageVisits(
            step,
            pageVisitTracking
          );
        if (pageVisitValidation.valid) {
          return { valid: true };
        }

        return {
          valid: false,
          reason:
            'Please review and approve all transaction types before completing this step',
        };
      })
    );
  },
  pageVisitTracking,
};
